import React, { Component } from 'react';
import { asyncComponent } from 'react-async-component';
import PropTypes from 'prop-types';

const Segment = asyncComponent({
    resolve: () => import('./Segment'),
});

export default class SegmentWrapper extends Component {
    render() {
        return(
            <div>
                <Segment config={this.props.config} reportEvent={this.props.reportEvent(this.props.config.id)} />
            </div>
        );
    }
}

SegmentWrapper.propTypes = {
    config: PropTypes.object.isRequired,
};
